import React, { useState } from 'react';
import { LoadingButton } from '../common/LoadingButton'

export const AuthLogin = ({ ballot, onValidateLogin }) => {
    const [isSubmitting, setSubmitting] = useState(false)
    const [voterId, setVoterId] = useState("")
    const [password, setPassword] = useState("")

    const handleLogin = () => {
        setSubmitting(true)

        // Validate receipt
        onValidateLogin(voterId, password, () => { setSubmitting(false) })
    }

    const handleIdInput = (event) => {
        setVoterId(event.target.value)
    }

    const handlePasswordInput = (event) => {
        setPassword(event.target.value)
    }

    const uniqueIdLabel = (ballot && ballot.uniqueIdLabel) ? ballot.uniqueIdLabel : "Voter ID"
    const passwordLabel = (ballot && ballot.passwordLabel) ? ballot.passwordLabel : "Password"
    const welcomeLabel = (ballot && ballot.loginFormStatement) ? ballot.loginFormStatement : "Please login with the details provided in your voting instructions"

    return (
        <form>
            <p className="text-center mb-2">{welcomeLabel}</p>

            <div className="mb-4">
                <label htmlFor="voterId" className="block font-medium mb-2">{uniqueIdLabel}</label>
                <input id="voterId" type="text" onChange={handleIdInput} value={voterId} placeholder={uniqueIdLabel} required />
            </div>

            <div className="mb-4">
                <label htmlFor="password" className="block font-medium mb-2">{passwordLabel}</label>
                <input id="password" type="password" onChange={handlePasswordInput} value={password} placeholder={passwordLabel} required />
            </div>

            <div className="mt-8">
                <LoadingButton className="btn w-full block"
                    btnText="Login"
                    isLoading={isSubmitting}
                    onBtnClick={handleLogin}
                    isSubmit="true" />
            </div>
        </form>
    );
}